<div class="bg-blue-800 text-white text-left px-8 py-16 text-3xl rounded-b-md">
  Recommandation
</div>
<div class="grid gap-4 w-full p-8">
  <div>
    <button
      mat-raised-button
      class="text-xl py-4 bg-green-500 text-white w-120"
      (click)="showAddModal()"
    >
      <mat-icon>add</mat-icon> Ajouter une recommandation
    </button>
    <div class="grid mt-10">
      <label>Utilisateur</label>
      <unilog-recherche
        style="width: 235px"
        appearance="outline"
        champsModel="Tiers_code"
        champsAffiche="Tiers_RS"
        [ServerSideFiltering]="true"
        textErreur="Veuillez Entrer un tier valide"
        [showError]="true"
        recherche="API_ListeRep"
        [api]="generalService.api"
        placeholder="Nom"
        [(ngModel)]="searchUser"
        (ChampEnter)="searchCmdsByUsers()"
      >
      </unilog-recherche>
    </div>
  </div>
  <div class="shadow overflow-hidden rounded border-b border-gray-200">
    <table class="w-full bg-white">
      <thead class="bg-gray-800 text-white">
        <tr>
          <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
            Date
          </th>
          <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
            Client
          </th>
          <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
            Type
          </th>
          <!-- <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
            Motif
          </th> -->
          <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
            commentaire
          </th>
        </tr>
      </thead>
      <tbody class="text-gray-700">
        <tr
          *ngFor="let detail of data; index as i"
          [class]="i % 2 == 0 ? 'bg-gray-100' : ''"
        >
          <td class="text-left py-3 px-16">
            {{ detail.Date_Create | date: "dd-MM-yyyy" }}
          </td>
          <td class="text-left py-3 px-16">{{ detail.Tiers_RS }}</td>
          <td class="text-left py-3 px-16">{{ detail.type }}</td>
          <!-- <td class="text-left py-3 px-16">{{ detail.motif }}</td> -->
          <td class="text-left py-3 px-16">{{ detail.Commentaire }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<ng-template #addCommand>
  <div class="text-3xl text-gray-700 font-bold mb-4">
    Ajouter une recommandation
  </div>
  <unilog-recherche
    class="w-full"
    required
    appearance="outline"
    champsModel="Tiers_code"
    champsAffiche="Tiers_RS"
    [ServerSideFiltering]="true"
    textErreur="Veuillez Entrer un tier valide"
    [showError]="true"
    recherche="API_ListeRep"
    [api]="generalService.api"
    placeholder="Représentant"
    [(ngModel)]="CRM_DS.CRMActivity[0].User_Id"
  >
  </unilog-recherche>
  <unilog-recherche
    class="w-full"
    required
    appearance="outline"
    champsModel="Tiers_code"
    champsAffiche="Tiers_RS"
    [ServerSideFiltering]="true"
    textErreur="Veuillez Entrer un tier valide"
    [showError]="true"
    recherche="Tier"
    [api]="generalService.api"
    placeholder="Client"
    [(ngModel)]="CRM_DS.CRMActivity[0].Tiers_code"
  >
  </unilog-recherche>
  <mat-form-field appearance="outline" class="w-full mt-8">
    <mat-label>Type</mat-label>
    <mat-select
      matNativeControl
      required
      [(ngModel)]="typeSelected"
      (selectionChange)="changeMotif()"
    >
      <mat-option *ngFor="let type of types" [value]="type.DiverSys_Libelle">{{
        type.DiverSys_Libelle
      }}</mat-option>
    </mat-select>
  </mat-form-field>
  <!-- <mat-form-field appearance="outline" class="w-full mt-8" *ngIf="typeSelected">
    <mat-label>Motif</mat-label>
    <mat-select
      matNativeControl
      required
      [(ngModel)]="CRM_DS.CRMActivity[0].CRMActivity_Sujet"
    >
      <mat-option *ngFor="let motif of motifs" [value]="motif">{{
        motif
      }}</mat-option>
    </mat-select>
  </mat-form-field> -->
  <mat-form-field class="w-full" appearance="outline">
    <mat-label>laissez un commentaire</mat-label>
    <textarea
      matInput
      placeholder="Ex. Ça me fait sentir..."
      [(ngModel)]="CRM_DS.CRMActivity[0].CRMActivity_Description"
    ></textarea>
  </mat-form-field>
  <div class="flex w-full justify-center">
    <button
      (click)="submit()"
      mat-raised-button
      color="primary"
      class="w-full md:text-2xl sm:text-base py-2"
    >
      Ajouter une recommandation
    </button>
  </div>
</ng-template>
